var render = function render(){var _vm=this,_c=_vm._self._c;return _c('transition',{attrs:{"name":_vm.transitionName,"appear":"","mode":"out-in"}},[_c(_vm.useLayout,{tag:"component"},[_vm._t("default")],2)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }